import React, { Component } from "react";
import BreadcrumbCustomer from "../breadcrumb";
import {  Form, Input, Select, Button,message, Divider} from 'antd';
import {dbFields}  from '../../model/customs/column';
import { route } from "../../routes/routes";
import { createCustom, getCustomList } from "../../model/customs/requests";
import { configs } from "../../config/config";
import storage from "../../utils/storage";


export const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
};
const Option = Select.Option;
export const tailLayout = {
    wrapperCol: {
      offset: 8,
      span: 16,
    },
};

class CustomCreate extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            data: {
                type: null,
                name:null
            },
            groupList: [],
        }
    };
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }

    handlerSubmit=(e)=>{
        let  name = this.formRef.current.getFieldValue(dbFields.name.key);
        let  desc = this.formRef.current.getFieldValue(dbFields.desc.key);
        let app_name1 = this.formRef.current.getFieldValue(dbFields.app_name1.key);
        let app_name2 = this.formRef.current.getFieldValue(dbFields.app_name2.key);
        let app_url1 = this.formRef.current.getFieldValue(dbFields.app_url1.key);
        let app_url2 = this.formRef.current.getFieldValue(dbFields.app_url2.key);

        createCustom({name:name,desc:desc,app1_name:app_name1,appmanifest1:app_url1,app2_name:app_name2,appmanifest2:app_url2}).then(res=>{
            if(res.data.code === 200){
                message.success(configs.http.responseMsg.created)
                setTimeout(()=>{
                    this.props.history.push(route.group.index)
                },1000)
            }else{
                message.error(res.data.msg)
            }
        
        }).catch(err=>{
            message.error(err)
        })
    };

    render() {
        return (
            <>
                <BreadcrumbCustomer   first='Custom' second='Create' />
                <Divider />
                <Form
                    {...layout}
                    ref={this.formRef}
                    initialValues={{
                        remember: true,
                    }}
                >
                        <Form.Item
                            name= {dbFields.name.key}
                            label={dbFields.name.title}
                    
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name= {dbFields.desc.key}
                            label={dbFields.desc.title}
                    
                        >
                            <Input.TextArea />
                        </Form.Item>
                        <Form.Item
                            name= {dbFields.app_name1.key}
                            label={dbFields.app_name1.title}
                    
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name= {dbFields.app_url1.key}
                            label={dbFields.app_url1.title}
                    
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name= {dbFields.app_name2.key}
                            label={dbFields.app_name2.title}
                    
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name= {dbFields.app_url2.key}
                            label={dbFields.app_url2.title}
                    
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            wrapperCol={{
                                span: 12,
                                offset: 6,
                              }}
                        >
                            <Button 
                            type="primary" 
                            onClick = {this.handlerSubmit}
                      
                                 style={{background: "#851dd6",color:"white" }}
                                 >
                                Submit
                            </Button>
                        </Form.Item>    
                </Form>    
            </>
        );
    }
}

export default CustomCreate;